/* eslint eqeqeq: "off", no-extend-native: "off", no-throw-literal: "off", no-use-before-define: "off" */

import React, { useRef, useState, useEffect } from 'react';
import firebase from 'firebase/app';
//we need firebase because we're saving data files to the cloud, and we want to authorize people
import axios from 'axios';
import { config } from '../config';
import OpenDataModal from './OpenDataModal';
import { useAppSelector } from '../redux/hooks';
import { store } from '../redux/store';
import { load } from '../redux/reducers/packetDataSlice';
import { selectProjectId } from '../redux/reducers/projectIdSlice';
import { selectData } from '../redux/reducers/packetDataSlice'

function DataTable(props) {

    const packetData = useAppSelector(selectData);
    const projectId = useAppSelector(selectProjectId);
    const [dataModalOpen, setDataModalOpen] = useState(false);

    const toggleModal = () => {
        setDataModalOpen(!dataModalOpen);
    }

    function pickFile() {
        if (document.getElementById("loadData") !== null) {
            document.getElementById("loadData").click();
        }

    }

    function importData() {

        //In the current version of packets we expect 9 columns - Type, Time, ADC 0 - 5, Checksum. Even if all the sensors aren't used,
        //this is what we're looking for. CSV is comma deli... comma is used to separate the columns.

        var parsedFile = [];

        const input = document.getElementById("loadData");
        const file = input.files[0];
        var fileReader = new FileReader();

        fileReader.onload = function (fileLoadedEvent) {
            var textFromFileLoaded = fileLoadedEvent.target.result;
            var textInLines = textFromFileLoaded.split("\n"); //create an array of lines
            textInLines.shift(); //remove header; we assume it exists but should probably check

            for (var line of textInLines) {
                var lineData = line.split(",");
                parsedFile.push(lineData);
            }

            store.dispatch(load(parsedFile))
        }

        fileReader.readAsText(file, "UTF-8");

    }

    function exportData() {
        var filename = "data.csv";
        var headers = ["Date", "Time", "Unix Time", "A0 (Lux)", "A1 (C)", "A2 (C)", "A3 (C)"];
        if (packetData[0] && packetData[0][7] !== undefined) {
            headers.push("A4 (Lux)");
        }
        if (packetData[0] && packetData[0][8] !== undefined) {
            headers.push("A5 (ADU)");
        }

        var textToSave = headers.join(",") + "\n";
        if (packetData) {
            for (var dataLine of packetData) {
                for (var i = 0; i < dataLine.length; i++) {
                    if (i == 0) {
                        textToSave += dataLine[0];
                    } else {
                        textToSave += "," + dataLine[i];
                    }
                }
                textToSave += "\n";

            }
            var newFile = new Blob([textToSave], { type: 'plain/text' });
            var a = document.createElement("a"),
                url = URL.createObjectURL(newFile);
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            setTimeout(function () {
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            }, 0);
        }

    }

    const saveToCloud = () => {
        firebase.auth().currentUser.getIdToken(false).then(idToken => {

            axios.post(`${config.apiUrl}/data/${projectId}`, {
                authorization: idToken,
                data: packetData,
            }).then((response) => {

            }).catch((err) => { console.log(err) })
        })
    }


    {/* I will probably end up removing this -- 1/15/2025 */}
    {/*Temporarily removed to see if it breaks anything, if nothing breaks I'll remove it for good -- 6/30/26 */}
    // const [units, setUnits] = useState(true);

    // const setUnitsState = () => {
    //     setUnits(!units);
    //     store.dispatch(load([]));
    // }
    
    const clearPacketData = () => {
        store.dispatch(load([]));
    };


    //dataRef and the below use effect are for making the datatable always scroll to bottom.
    //Eventually I want to make a settings menu where stuff like this can be configurable. -- 6/30/26
    const dataRef = useRef(null);

    useEffect(()=>{
        dataRef.current.scrollTop = dataRef.current.scrollHeight
    }, [packetData])

    let row = 0;
    return (
        <div  id='testDataTable' ref={dataRef}  style={{ overflow: "scroll", height: "100%", width: "100%" }}>
            {dataModalOpen ? <OpenDataModal toggleModal={toggleModal} pid={projectId} /> : null}
            
            <div style={{borderBottom: '1px solid #ccc', padding: '10px', position:'sticky', top: 0, backgroundColor: 'white', width: '98%', zIndex: 3, boxShadow: '0 4px 2px -2px rgba(0,0,0,0.1)'}}>
                <span className='dataTableButtons'  onClick={exportData.bind(this)} style={{ cursor: 'pointer' }}>Export</span>
                <input id="loadData" type="file" accept=".csv, .pac" onChange={() => importData()} style={{ display: "none" }} />
                <span className='dataTableButtons'  onClick={pickFile} style={{ marginLeft: "20px", cursor: 'pointer' }}>Import</span>
                <span className='dataTableButtons' onClick={()=>clearPacketData()} style={{marginLeft: "20px", cursor: 'pointer' }}>Clear</span>
                {projectId && packetData ?
                    <>
                        <span className='dataTableButtons'  onClick={saveToCloud} style={{ marginLeft: "20px", cursor: 'pointer' }}>Save</span>
                        <span className='dataTableButtons'  onClick={() => { toggleModal() }} style={{ marginLeft: "20px", cursor: 'pointer' }}>Open</span>
                    </>
                    :
                    <>
                        <span style={{ marginLeft: "20px", color: 'gray' }}>Save</span>
                        <span style={{ marginLeft: "20px", color: 'gray' }}>Open</span>
                    </>
                }

            </div>

            <table className="dataTable" style={{ width: "98%" }}>
                <thead style={{ textAlign: "center"}}>
                    <tr>
                        <th>Date</th>
                        <th>Time</th>
                        <th>Unix Time</th>
                        <th>A0 (Lux)</th>
                        <th>A1 (°C)</th>
                        <th>A2 (°C)</th>
                        <th>A3 (°C)</th>
                        {packetData[0] && packetData[0][7] !== undefined ? <th>A4 (Lux)</th> : null}
                        {packetData[0] && packetData[0][8] !== undefined ? <th>A5 (ADU)</th> : null}
                    </tr>
                </thead>
                <tbody style={{ textAlign: 'center' }}>
                    {packetData.map(dataLine => {
                        row++;//added to stop getting warnings about matching keys when time is the same (less than a second)
                        return (
                            <tr key={`${dataLine[0]}row${row}`}>
                                {/* <td key={`${dataLine[0]}${row}type`} >{dataLine[0]}</td> */}
                                <td key={`${dataLine[0]}${row}date`} >{dataLine[0]}</td>
                                <td key={`${dataLine[0]}${row}time`}>{dataLine[1]}</td>
                                <td key={`${dataLine[0]}${row}unix`}>{dataLine[2]}</td>
                                <td key={`${dataLine[0]}${row}Lux1`}>{dataLine[3]}</td>
                                <td key={`${dataLine[0]}${row}C1`}>{dataLine[4]}</td>
                                <td key={`${dataLine[0]}${row}C2`}>{dataLine[5]}</td>
                                <td key={`${dataLine[0]}${row}C3`}>{dataLine[6]}</td>
                                
                                {dataLine[7] !== undefined ? <td key={`${dataLine[0]}${row}Lux2`}>{dataLine[7]}</td> : null}
                                {dataLine[8] !== undefined ? <td key={`${dataLine[0]}${row}ADU`}>{dataLine[8]}</td> : null}
                                

                                {/* The following 3 lines are being removed for the PLE in January 2025, will be put back after */}
                                {/* <td key={`${dataLine[0]}${row}ping`}>{dataLine[7]}</td> */}
                                {/* <td key={`${dataLine[0]}${row}ms`}>{dataLine[7]}</td> */}
                                {/* <td key={`${dataLine[0]}${row}ms2`}>{dataLine[7]}</td> */}
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </div>
    )
}

export default DataTable;